module.exports = __webpack_public_path__ + "img/4.42f16cce.jpg";